import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import { Grid } from '@mui/material';
import { PageHeader } from 'components/ui/Global/PageHeader';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { OrderHeaderButtonDetails } from './Components/OrderStyleConfig';

export const OrderDetail = () => {
  const { t } = useTranslation();

  const OrderHeaderLinks = OrderHeaderButtonDetails(null, null).map(
    (button) => ({
      ...button,
      name: t(button.name), // Localize the name here
    })
  );

  // INITIALIZATION

  // API

  // HANDLES

  // EFFECTS

  return (
    <Grid container direction='row' spacing={0}>
      <Grid item xs={12} sx={{}}>
        <PageHeader
          Icon={ReceiptRoundedIcon}
          title={t('Orders.orderDetail.orders')}
          FormJSX={null}
          HeaderButtons={OrderHeaderLinks}
        />
      </Grid>

      <Grid item xs={12} sx={{}}>
        <Outlet />
      </Grid>
    </Grid>
  );
};
